import './chart_view.js.coffee';# Added by Script 
import './ticket_count_chart_view.js.coffee'
Namespace 'CustomerVisualMode.Charts'

class CustomerVisualMode.Charts.TicketInteractionsAverageChartView extends CustomerVisualMode.Charts.ChartView
  template: JST['backbone/templates/customer_visual_mode/charts/ticket_interactions_average_chart']
  className: 'grid-item full-width-chart'
  @NAME: 'average_ticket_interactions'

  initialize: ({widget, data, session, isReadOnly, isResponsive}) ->
    title = I18n.t('customer_visual_mode.charts.ticket_interactions_average.title')
    description = I18n.t('customer_visual_mode.charts.ticket_interactions_average.description')
    super({widget, title, description, data, session, isReadOnly, isResponsive})

  render: ->
    super()
    @$el.find('.chart').html @template
    @_ticketInteractionsAverageCardViews().forEach (view) =>
      @$('.ticket-interactions-average-chart').append(
        view.render().el
      )
      @listenTo(view, 'ticketCountCard:click', @_openDrilldown)
    @

  _ticketInteractionsAverageCardViews: ->
    [
      @_generalAverageView()
      @_userAverageView()
      @_botAverageView()
    ]

  _generalAverageView: ->
    @generalAverageView ||= new CustomerVisualMode.Charts.TicketCountCardView(
      id: 'ticket_with_incoming_and_outgoing_interactions'
      count: @_getAverageValue('average_incoming_and_outgoing_ticket_interactions')
      iconClass: 'fa fa-tags'
      clickable: true
      title: I18n.t('customer_visual_mode.charts.ticket_interactions_average.general_average')
    )

  _userAverageView: ->
    @userAverageView ||= new CustomerVisualMode.Charts.TicketCountCardView(
      id: 'ticket_with_incoming_interactions'
      count: @_getAverageValue('average_incoming_ticket_interactions')
      iconClass: 'fa fa-user'
      clickable: true
      title: I18n.t('customer_visual_mode.charts.ticket_interactions_average.user_average')
    )

  _botAverageView: ->
    @botAverageView ||= new CustomerVisualMode.Charts.TicketCountCardView(
      id: 'ticket_with_outgoing_interactions'
      count: @_getAverageValue('average_outgoing_ticket_interactions')
      iconClass: 'robot-icon'
      clickable: true
      title: I18n.t('customer_visual_mode.charts.ticket_interactions_average.bot_average')
    )

  _getAverageValue: (key) =>
    parseFloat(@data[key]).toFixed(1)

  _openDrilldown: (id) ->
    data = {
      dimensions: ['average_ticket_interactions'],
      name: 'Tickets interactions average',
      drilldown_code: id,
      timezone: moment().format('Z')
    }
    super(data)
